import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import UserSettingsProfileButton from './UserSettingsProfileButton';

loadDOMComponent({
	selector: 'react-user-settings-profile-button',
	callback: ({ container, context, props }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<UserSettingsProfileButton />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
